import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 1rem;
`;

export { Container };
